var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115.56,
    height: 34.24,
    viewBox: "0 0 115.56 34.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a6a6a6;}.b,.i,.j{fill:#fff;}.c{fill:url(#a);}.d{fill:url(#b);}.e{fill:url(#c);}.f{fill:url(#d);}.g{opacity:0.2;}.h{opacity:0.12;}.i{opacity:0.25;}.j{stroke:#fff;stroke-miterlimit:10;stroke-width:0.2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.915,
    y1: 6.614,
    x2: -0.382,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.077,
    y1: 17.089,
    x2: -1.306,
    y2: 17.089,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.863,
    y1: 10.855,
    x2: -0.502,
    y2: 9.087,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.188,
    y1: 13.576,
    x2: 0.421,
    y2: 12.786,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.56,
    height: 34.24,
    rx: 5,
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M121.28,10.685a3.6,3.6,0,0,1,3.6,3.6V39.96a3.6,3.6,0,0,1-3.6,3.6h-107a3.6,3.6,0,0,1-3.6-3.6V14.28a3.6,3.6,0,0,1,3.6-3.6h107m0-.685h-107A4.28,4.28,0,0,0,10,14.28V39.96a4.28,4.28,0,0,0,4.28,4.28h107a4.28,4.28,0,0,0,4.28-4.28V14.28A4.28,4.28,0,0,0,121.28,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.214,31.072a3.647,3.647,0,1,0,3.655,3.638,3.587,3.587,0,0,0-3.655-3.638Zm0,5.846a2.208,2.208,0,1,1,2.054-2.208,2.106,2.106,0,0,1-2.054,2.208Zm-7.978-5.846a3.647,3.647,0,1,0,3.655,3.638,3.587,3.587,0,0,0-3.655-3.638Zm0,5.846A2.208,2.208,0,1,1,68.29,34.71a2.106,2.106,0,0,1-2.054,2.208Zm-9.484-4.725v1.541h3.7a3.227,3.227,0,0,1-.856,1.943,3.784,3.784,0,0,1-2.859,1.13,4.109,4.109,0,1,1,0-8.218,3.972,3.972,0,0,1,2.808,1.1l1.087-1.087a5.393,5.393,0,0,0-3.878-1.558,5.658,5.658,0,1,0,0,11.308A5.2,5.2,0,0,0,60.7,36.773a5.136,5.136,0,0,0,1.335-3.621,5.367,5.367,0,0,0-.077-.959Zm38.785,1.2A3.363,3.363,0,0,0,89,34.71a3.621,3.621,0,0,0,6.643,2.029L94.4,35.883a2.063,2.063,0,0,1-1.789,1,1.84,1.84,0,0,1-1.763-1.1l4.871-2.012Zm-4.965,1.216a2,2,0,0,1,1.909-2.131,1.4,1.4,0,0,1,1.344.779Zm-3.955,3.527h1.6v-10.7h-1.6ZM84,31.886h-.06a2.517,2.517,0,0,0-1.917-.856,3.647,3.647,0,0,0,0,7.285,2.465,2.465,0,0,0,1.917-.856H84v.522c0,1.4-.745,2.14-1.943,2.14a2.02,2.02,0,0,1-1.84-1.293l-1.387.574a3.424,3.424,0,0,0,3.227,2.157c1.875,0,3.424-1.1,3.424-3.792v-6.48H84Zm-1.84,5.033a2.208,2.208,0,0,1,0-4.408,2.21,2.21,0,0,1,0,4.408Zm20.878-9.484H99.2v10.7h1.6V34.077h2.234a3.33,3.33,0,1,0,0-6.643Zm0,5.136H100.8V28.924h2.268a1.832,1.832,0,1,1,0,3.664Zm9.878-1.532a2.987,2.987,0,0,0-2.85,1.635l1.412.591a1.524,1.524,0,0,1,1.464-.779,1.541,1.541,0,0,1,1.712,1.378v.1a3.578,3.578,0,0,0-1.669-.411c-1.524,0-3.082.856-3.082,2.414a2.474,2.474,0,0,0,2.662,2.354,2.268,2.268,0,0,0,2.037-1.044h.051v.856h1.541V34.017a2.951,2.951,0,0,0-3.244-2.962Zm-.2,5.864c-.522,0-1.25-.265-1.25-.907,0-.856.907-1.147,1.712-1.147a2.842,2.842,0,0,1,1.455.36,1.935,1.935,0,0,1-1.883,1.712Zm9.091-5.615-1.832,4.64h-.051l-1.9-4.64h-1.712l2.85,6.488-1.626,3.6H119.2l4.383-10.092Zm-14.381,6.848h1.592v-10.7h-1.592Z",
    transform: "translate(-5.886 -2.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.372,17.53a1.712,1.712,0,0,0-.4,1.2V37.663a1.661,1.661,0,0,0,.4,1.2l.06.068L31.037,28.324v-.257L20.432,17.47Z",
    transform: "translate(-1.435 -1.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.41,33.047,32.9,29.512v-.257l3.51-3.535.077.051,4.2,2.38a1.3,1.3,0,0,1,0,2.474L36.5,33Z",
    transform: "translate(-3.298 -2.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M34.718,33.612,31.106,30,20.44,40.666a1.387,1.387,0,0,0,1.772.06l12.506-7.113",
    transform: "translate(-1.503 -2.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M34.718,24.535l-12.506-7.1a1.378,1.378,0,0,0-1.772.051L31.106,28.147Z",
    transform: "translate(-1.503 -1.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M34.615,34.13l-12.4,7.062a1.421,1.421,0,0,1-1.712,0h0l-.06.06h0l.06.068h0a1.421,1.421,0,0,0,1.712,0l12.506-7.113Z",
    transform: "translate(-1.503 -3.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.376,42.117A1.712,1.712,0,0,1,20,40.91v.128a1.661,1.661,0,0,0,.4,1.2l.06-.06Z",
    transform: "translate(-1.439 -4.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M41.28,31.113,37,33.535l.077.077,4.2-2.38A1.5,1.5,0,0,0,42.187,30h0a1.592,1.592,0,0,1-.907,1.113Z",
    transform: "translate(-3.888 -2.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M22.144,17.551l16.683,9.484a1.592,1.592,0,0,1,.907,1.113h0a1.5,1.5,0,0,0-.907-1.233L22.144,17.431c-1.19-.685-2.174-.12-2.174,1.25v.128C20,17.44,20.954,16.875,22.144,17.551Z",
    transform: "translate(-1.436 -1.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M52.059,22.136H51.4V17h1.755a1.609,1.609,0,0,1,1.13.437,1.5,1.5,0,0,1,0,2.183,1.609,1.609,0,0,1-1.13.437h-1.1Zm0-2.714h1.1a.895.895,0,1,0,0-1.789h-1.1Z",
    transform: "translate(-5.962 -1.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M60.44,21.449a2.662,2.662,0,0,1-3.766,0,2.773,2.773,0,0,1,0-3.8,2.645,2.645,0,0,1,4.528,1.9,2.568,2.568,0,0,1-.762,1.9Zm-3.278-.428a1.9,1.9,0,0,0,1.4.582,1.875,1.875,0,0,0,1.4-.582,2.174,2.174,0,0,0,0-2.945,1.875,1.875,0,0,0-1.4-.582,1.9,1.9,0,0,0-1.4.582,2.2,2.2,0,0,0,0,2.945Z",
    transform: "translate(-6.612 -0.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M63.17,22.136V17h1.858a1.549,1.549,0,0,1,1.044.394,1.31,1.31,0,0,1,.437,1,1.121,1.121,0,0,1-.188.651,1.156,1.156,0,0,1-.505.419h0a1.258,1.258,0,0,1,.625.445,1.147,1.147,0,0,1,.24.728,1.344,1.344,0,0,1-.462,1.044,1.549,1.549,0,0,1-1.087.419Zm.659-2.936h1.2a.762.762,0,0,0,.6-.248.8.8,0,0,0,.223-.539.788.788,0,0,0-.214-.539.745.745,0,0,0-.582-.24H63.829Zm0,2.3h1.327a.77.77,0,0,0,.616-.265.8.8,0,0,0,0-1.156.856.856,0,0,0-.633-.265h-1.31Z",
    transform: "translate(-7.656 -1.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M68.31,22.136V17h.659v5.136Z",
    transform: "translate(-8.397 -1.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M73.5,17.633H71.125V19.26h2.106v.616H71.125V21.5H73.5v.633h-3V17h3Z",
    transform: "translate(-8.712 -1.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M75.17,22.136V17h1.712a1.609,1.609,0,0,1,1.13.437,1.4,1.4,0,0,1,.479,1.1,1.464,1.464,0,0,1-.351.95,1.507,1.507,0,0,1-.856.514h0l1.438,2.14h-.779l-1.387-2.08h-.728v2.08Zm.659-2.7h1.061a.967.967,0,0,0,.676-.257.9.9,0,0,0-.633-1.549h-1.1Z",
    transform: "translate(-9.384 -1.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M79.85,22.136v-.685l2.7-3.818H79.978V17H83.4v.685L80.672,21.5H83.4v.633Z",
    transform: "translate(-10.058 -1.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M86.75,22.136v-.685l2.731-3.818H86.861V17h3.424v.685L87.555,21.5h2.756v.633Z",
    transform: "translate(-11.052 -1.008)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayFull);
export default __webpack_public_path__ + "static/media/google_play_full.587e2cb4e4d71895abb776a24c47f252.svg";
export { ForwardRef as ReactComponent };